module.exports = __webpack_public_path__ + "img/kids-6-640.71278fd6.jpg";